import { render, staticRenderFns } from "./MyCompanyLocationsNew.vue?vue&type=template&id=6138f7ed&"
import script from "./MyCompanyLocationsNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyLocationsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports